import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route
} from '@angular/router';
import { UserService } from './user.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router, private userService: UserService, private logService: LogService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;

    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    //
    // User tried to activate a protected page.
    // Check authentication and redirect to log on screen if necessary.
    //
    if (this.userService.isLoggedOn) {
      return true;
    }

    this.logService.logMessage('checkLogin(); User not logged on. Force authentication.');

    //
    // Store the attempted URL for redirecting
    //
    this.userService.redirectUrl = url;

    //
    // Route back to login
    //
    this.router.navigate(['/']);
    return false;
  }
}